// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2W3VR","h2":"styles_h2__pYIT3","h3":"styles_h3__19D0L","h4":"styles_h4__3H0LY"};